<div class="row">
  <div class="col-7 mb-4">
    <app-card-wrapper [title]="title">
      <p *ngIf="!global.subscription.IsActive" class="mb-0">
        Ondanks het feit dat je (proef)abonnement op Assist is verlopen, kan je Assist toch nog
        gratis gebruiken met volgende mogelijkheden:
      </p>
      <p *ngIf="global.subscription.IsActive">
        Momenteel gebruik je
        <strong>{{ global.subscription.SubscriptionType.Name }}</strong
        >, <span *ngIf="global.subscription.SubscriptionType.Id == 5">de gratis versie</span
        ><span *ngIf="global.subscription.SubscriptionType.Id == 4">de basisversie</span>
        van Assist. Met deze versie kan je:
      </p>
      <p>
        <span>
          <ul>
            <li>
              Vacatures toevoegen en beheren op
              <a
                href="https://www.vrijwilligerswerk.be/"
                target="_blank"
                class="text-decoration-underline"
                >vrijwilligerswerk.be</a
              >
            </li>
            <li>Kandidaat-vrijwilligers beheren die solliciteren op een vacature</li>
            <li *ngIf="global.organization.FederationId == federations.VlaamseSportfederatie">
              Taken en vrijwilligers beheren met de Supportplanner
            </li>
          </ul>
        </span>
      </p>
      <p>
        @switch (rubriek) {
          @case ("boekhouding") {
            In Assist PLUS, de volledige versie van Assist, kan je zowel als niet btw-plichtige of
            als (gemengd) btw-plichtige vereniging de boekhouding van je vereniging beheren.
          }
          @case ("leden") {
            In <strong>Assist PLUS</strong>, de volledige versie van Assist, kan je o.a.:
            <span>
              <ul>
                <li>Jouw leden indelen in ledengroepen</li>
                <li>Het lidgeld online innen</li>
                <li>Leden uitnodigen voor activiteiten en lessenreeksen</li>
                <li>Per lid een 'doorstromingstraject' beheren</li>
                <li>Het attest voor het ziekenfonds opmaken</li>
                <li>En zoveel meer...</li>
              </ul>
            </span>
          }
          @case ("vrijwilligers") {
            In <strong>Assist PLUS</strong>, de volledige versie van Assist, kan je o.a.:
            <span>
              <ul>
                <li>Jouw vrijwilligers indelen in vrijwilligersgroepen</li>
                <li>Afsprakennota's maken</li>
                <li>Kosten en kostennota's beheren</li>
                <li>Een vrijwilligersregister opmaken</li>
                <li>En zoveel meer...</li>
              </ul>
            </span>
          }
        }
      </p>
      <p>
        <a
          href="https://assistonline.eu/prijs-vereniging"
          target="_blank"
          class="text-decoration-underline"
          >Klik hier</a
        >
        voor een volledig overzicht van alle mogelijkheden van Assist PLUS.
      </p>
      <div class="d-block">
        <a
          *ngIf="!global.subscription.IsTemporaryPlus"
          class="btn btn-success mt-3 mb-0 me-3"
          (click)="startTrail()"
        >
          <span *ngIf="startingTrail"><i class="fas fa-circle-notch fa-spin"></i>&nbsp;&nbsp;</span>
          Start 30 dagen proefabonnement
        </a>
        <a class="btn btn-primary mt-3 mb-0" (click)="showSubscription()">
          <span *ngIf="global.subscription.SubscriptionType.Id == 4"> Assist PLUS activeren </span>
          <span *ngIf="global.subscription.SubscriptionType.Id == 1">
            Je abonnement op Assist verlengen
          </span>

          <span *ngIf="global.subscription.SubscriptionType.Id == 5">
            Assist START of PLUS activeren
          </span>
        </a>
      </div>
    </app-card-wrapper>
  </div>
  <div *ngIf="url" class="col-5 mb-4 position-relative">
    <app-card-wrapper [title]="'Volg de rondleiding'" [hasIntro]="true">
      <p *ngIf="rubriek == 'boekhouding'">
        Benieuwd naar hoe je in Assist je boekhouding kan beheren? Krijg dan in enkele minuten een
        rondleiding doorheen de rubriek 'Kostenvergoedingen'.
      </p>
      <p *ngIf="rubriek == 'vrijwilligers'">
        Benieuwd naar hoe je in Assist kosten en kostennota's kan beheren? Krijg dan in enkele
        minuten een rondleiding doorheen de rubriek 'Kostenvergoedingen'.
      </p>
      <ul class="nav flex-column bg-white border-radius-lg p-0">
        <li class="nav-item text-sm text-bold">
          <div class="d-flex">
            <div class="checklist-info me-2">
              <h6 class="checklist-title mb-0">
                <a href="{{ url }}" target="_blank">
                  <i class="fa-brands fa-youtube fs-4 me-1" style="color: #ff0000"></i>
                </a>
              </h6>
            </div>
            <div class="checklist-info">
              <h6 class="checklist-title mb-0">
                <a href="{{ url }}" target="_blank"> Bekijk het webinar </a>
              </h6>
            </div>
          </div>
        </li>
      </ul>
    </app-card-wrapper>
  </div>
</div>
